// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"24":"reset","681":"users","685":"register","768":"page"}[chunkId] + "." + {"24":"85e95554","681":"007052ca","685":"df2a94b1","768":"0e3112b1"}[chunkId] + ".css";
};